import { useEffect, useState } from 'react'
import { useMatches, useLocation } from 'react-router-dom'
import { INavItem } from '../route'

/**
 * 获取匹配的导航列表
 */
export const useActiveNav = (ns?: Array<INavItem>) => {
  const _window = window as any
  const location = useLocation()
  const matches = useMatches() as any
  const [matchNav, setMatchNav] = useState([] as any)

  useEffect(() => {
    const { navs = [] } = _window.__MICRO_APP_ENVIRONMENT__ ? _window.microApp.getData() : { navs: ns }
    // 获取导航列表
    let navIds = []

    // 获取匹配到的路由地址
    if (Array.isArray(matches) && matches.length > 0) {
      const { handle = {} } = matches[matches.length - 1] || {}
      if (handle && handle.code) {
        // 获取匹配到的导航，并获取路径
        const nav = navs.find((n: INavItem) => n.code === handle.code)
        if (nav?.idPath) {
          navIds = nav?.idPath.split(',')
          navIds.push(nav?.id || '')
        } else {
          navIds = [nav?.id || '']
        }
      }
    }

    const _matchNav: any = []
    navIds.forEach((n: string) => {
      const _nav = navs.find((item: INavItem) => item.id === n)
      _matchNav.push(_nav)
    })

    setMatchNav(_matchNav)
  }, [location])

  return matchNav
}
